import styled from 'styled-components';

export const Content = styled.div`
  & .cardContainer {
    display: flex;
    min-width: 100%;
    width: max-content;
    grid-gap: 20px;
    height: 285px;
    padding: 18px 0 0;
  }

  & .card {
    position: relative;

    &.free-seats h3 {
      text-decoration: line-through #b4b9d9;
      color: #b4b9d9;
    }
  }

  & .scrollContainer {
    overflow-x: auto;
    height: max-content;
    padding: 0 0 15px;
    margin: 0 0 20px;
    border-bottom: 1px solid #d5ddf2;
  }

  .buttonModalContainer {
    display: flex;
    position: sticky;
    bottom: 0;
    left: 0;
    background: var(--color-page);
    padding: 20px 0 30px;
    justify-content: space-between;

    width: 100%;

    & button {
      width: max-content;
    }
  }
`;
